import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';
import Modalexpercheck from './Modalexpercheck';
import Modalexpercommentscoreshow from './Modalexpercommentscoreshow';





export default class Commentexlistpsf extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   typelevel:'',
   commentbn:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
                        typelevel:this.props.typelevel,
         })
      setTimeout(() => {
       
        api.get('registercon/selectArticlespfexwhereidscore/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
        api.get('registercon/selectArticlespfexwhereidscore/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
             {this.state.commentbn.map((commentbn,index )  => 
             <>
             <p>กรรมการที่ {index+1} : {commentbn.name_expert}</p>

           <MDBTable small>
       <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ผลงาน</th>
          <th>วันที่ส่งผลงาน</th>
        
          <th>วันที่ประเมิน</th>
          <th>สถานะ ผ่าน/ปรับแก้ไข</th>
          <th>กรรมการผู้ตรวจ</th>
          <th>การส่งกลับ</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn[index].ex.map((ex,indexs )  => 
                        <tr>
                        <td>{indexs+1}</td>
                       
                        <td>{ex.send_uploadewordex !== null ? <>
                          <tr>
                            <td><a href={`${this.state.url+ex.send_uploadepdfex}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> PSF01 .pdf</p> </a></td>
                            <td><a href={`${this.state.url+ex.send_uploadepdfex2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> PSF02 .pdf</p> </a></td>
                            <td><a href={`${this.state.url+ex.send_uploadepdfex3}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> PSF03 .pdf</p> </a></td>
                            <td><a href={`${this.state.url+ex.send_uploadepdfex4}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> PSF04 .pdf</p> </a></td>
                          </tr>
                            {/* <a href={`${this.state.url+ex.send_uploadewordex}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .word</p> </a> */}
                            {/* <a href={`${this.state.url+ex.send_uploadepdfex}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .pdf</p> </a> */}
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{ex.dateaddex}</td>

                      

                        <td>{ ex.date_addcr !== null ?<>{ex.date_addcr}</>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td >{ex.scoreall==='2'?<> <span className="teal-text font-weight-bold">ผ่าน</span></>:<>
                               {ex.scoreall==='3'?<><span className="teal-text font-weight-bold">ผ่าน มีแก้ไข (ไม่ขอดูไฟล์)</span></>:<>
                                {ex.scoreall==='4'?<><span className="text-warning font-weight-bold">ผ่าน มีแก้ไข (ขอดูไฟล์อีกครั้ง)</span></>:<>
                                 {ex.scoreall==='0'?<><span className="text-danger font-weight-bold">ไม่ผ่าน</span></>:<>
                                 <MDBIcon far icon="hourglass" /> รอพิจารณา
                                 </>}
                                 
                                </>}
                              
                               </>}
                            </>}
                        </td>


                         <td>{ex.name_expert}</td>

                        <td>
                          {/* {ex.statusex ==='2' || ex.statusex ==='0'  ?<>แจ้งกลับแล้ว</>:<>
                          {ex.statusex ==='3' ?<>ส่งกลับแล้ว</>:<><Modalexpercommentbacktbn id_articlepsf={ex.id_articlepsf} id_empbn={ex.id_empbn} idarticlebn={ex.idarticlebn} nameuserbn={ex.nameuserbn} send_uploadewordbn={ex.send_uploadewordbn}  send_uploadepdfbn={ex.send_uploadepdfbn} list={this.list}  /></> } 
                          </>} */}
                          {ex.scoreall === null ?<>
                          <MDBIcon far icon="hourglass" />
                          </>:<>
                          <Modalexpercommentscoreshow id_articlepsf={ex.id_articlepsf} id_expert={ex.id_expert} typelevel={this.props.typelevel} idarticleexcr={ex.idarticleexcr} nameuserex={ex.nameuserex} />
                          </>}
                        
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
    </>
         )}   
          </>
          
        )
    }
}


